import React,{useEffect, useState} from "react";
import { Grid } from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { convertEpochToTimestamp } from "../../utils";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import { URLDerectionData, getFiles, getInlineImage,getAnswerRatingsInNotificationAction,markUnmarkFavourite, getExpertsProfilePics } from "../../API/api";
import { replaceContentEditableText } from "../../utils";
import Tooltip from '@mui/material/Tooltip';
import { Rate } from "antd";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import { ReactComponent as ThumbsUpDownIcon } from "../../Icons/Union.svg";
import { ReactComponent as ThumbsUpDownFalseIcon } from "../../Icons/UnionFalse.svg";
import Button2 from "../../NewComponent/Button2/Button2";
import { ReactComponent as HeartIcon } from "../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../Icons/heartSelect.svg";
import { instance } from "../../API/api";
import { GET_FILES } from "../../API/url";




export default function RecentRatingCardNew(props) {
  const dispatch = useDispatch();
  const { updateSearchData2, advanceFilterModalToggle, getRecentRatingsQuestionText, getRecentRatingsAnswerText, getQuestionResponseData, loadingDataForMyStat,getRecentRatingsData,getBestQuestionsData,getWorstQuestionsData,getBetterRatingsData } = bindActionCreators(Actions, dispatch);
  const myStat = useSelector((state) => state.myStatsData);
  const [allInlineImages, setAllInlineImages] = useState(null);
  const domainReducer = useSelector((state)=>state.domain);
const [answerRatings,setAnswerRatings] = useState([]);


const containerStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  background: "#FFFFFF",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "24px 36px 24px 36px",
  minHeight: "100px",
  marginBottom: '24px'
};

  const getRatingValues = () => {
    if (props.data.rating === "1") {
      return (<><span style={{ fontSize: "12px", color: "#949494" }}>"Poor"</span></>)
    }
    if (props.data.rating === "2") {
      return (<><span style={{ fontSize: "12px", color: "#949494" }}>"Poor"</span></>)
    }
    if (props.data.rating === "3") {
      return (<><span style={{ fontSize: "12px", color: "#949494" }}>"Good"</span></>)
    }
    if (props.data.rating === "4") {
      return (<><span style={{ fontSize: "12px", color: "#949494" }}>"Very Good"</span></>)
    }
    if (props.data.rating === "5") {
      return (<><span style={{ fontSize: "12px", color: "#949494" }}>"Excellent"</span></>)
    }
  }
  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("ll");
    }
  };
  const starArray = [...Array(5).keys()].map(i => i + 1);
  const Rating = ({ rating }) => {
    // starArray.map(i => (
    //   <i key={i} className="fa fa-w fa-star" style={{ fontSize: "14px", padding: "2px", color: rating >= i ? "#FFE11A" : "lightgrey", cursor: "not-allowed" }}></i>
    // ));
    return (
      <>
      <Rate disabled={true} value={parseInt(rating)} />
      </>
    )
  }
  const openModalOnClick = () => {
   var answerUuids = [];
   var userUuids = [];
    getRecentRatingsQuestionText(props.data.questionText);
    if(props.data.answer && props.data.answer !== '')
    {
    getRecentRatingsAnswerText(props.data.answer);
    }
    URLDerectionData(props.data.questionUuid).then((res) => {
      if (res===undefined) return;
      loadingDataForMyStat(true);
      if (res.data.data !== undefined || res.data.success === true) {
        getQuestionResponseData(res.data.data);
        loadingDataForMyStat(false);
        answerUuids = res.data.data.answers.map((k) => k.originalAnswerUuid ?? k.docId ?? k.answerUuid);
        userUuids = res.data.data.answers.map((obj,ind)=>{
          if(obj.expertUuid && obj.expertUuid !== '')
          {
            return obj.expertUuid
          }
        })
        if(userUuids.length > 0 )
        {
        getExpertsProfilePics(userUuids,"")
        }
        getAnswerRatingsInNotificationAction(answerUuids.toString(),"").then((res) => {
          if (res===undefined) return;
          if (res.data.data !== undefined || res.data.success) {
            setAnswerRatings(res.data.data)
            updateSearchData2(res.data.data)
          }
        })
        if(res.data.data.answers && res.data.data.answers.length > 0 )
        {
          res.data.data.answers.filter((obj)=>{
            if(obj.inlineImages.length > 0 )
            {
              instance.post(GET_FILES,obj.inlineImages).then((res)=>{
                if(res === undefined ) return 
                if(res.data.success)
                {
                  for (let i = 0; i < obj.inlineImages.length; ++i) {
                    if (obj.inlineImages[i].includes(".png")) {
                      let replacedContent = `[content|${obj.inlineImages[i].split(".")[0]
                        }|]`;
                      let imgTag = `<img style='max-width:50%' src=${res.data.data[obj.inlineImages[i]]
                        }></img>`;
                      obj.answer = obj.answer.replaceAll(
                        replacedContent,
                        imgTag
                      );
                      // // console.log("png image",   answer.answerText)
                      // dispatch(res.data.data[0].searchData);
                    } else {
                      let imgTag = `<img style='max-width:50%' src=${res.data.data[obj.inlineImages[i]]
                        }></img>`;

                      let replacedContent = obj.inlineImages[i];
                      obj.answer = obj.answer.replaceAll(
                        replacedContent,
                        imgTag
                      );
                      // console.log("Search image", answer.answerText)
                      // dispatch(res.data.data[0].searchData);
                    }
                  }
                }
              })
            }
          })
        }
        advanceFilterModalToggle({ bool: true, value: "recentRatingsModal" });
      }
    })
  }

  // const replaceIdsWithImages = async(text) => {
  //   if (myStat.inlineImages !== null && myStat.inlineImagesData.length > 0 && props.data.answer.includes(props.data.answerUuidStr)) 
  //   {
  //     getInlineImage(myStat.inlineImagesData).then((res)=>{
  //       if(res.data.data !== undefined || res.data.success)
  //       {
  //         let inlineDatas = res.data.data;
  //         setAllInlineImages({...allInlineImages,inlineDatas});
  //       }
  //     });
  //     for (let i = 0; i < props.data.inlineImages.length; ++i) {
  //       if (props.data.inlineImages[i].includes(".png")) {
  //         let imgTag = `<img width=50% src=${
  //           allInlineImages.inlineDatas[props.data.inlineImages[i]]
  //         }></img>`;
  //         let replacedContent = `[content|${
  //           props.data.inlineImages[i].split(".")[0]
  //         }|]`;
  //         text = text.replaceAll(replacedContent, imgTag);
  //       } else {
  //         let imgTag = `<img width=50% src=${
  //           allInlineImages.inlineDatas[props.data.inlineImages[i]]
  //         }></img>`;
  //         let replacedContent = props.data.inlineImages[i];
  //         text = text.replaceAll(replacedContent, imgTag);
  //       }
  //     }
  //   }
  //   return text;
  // };

  const variable = () => {
    return (
      <>
      <Rate
        defaultValue={parseInt(props.data.rating)}
        disabled={true}
        // onChange={(e) => rateAnswer(e)}
      />
      </>
    );
  };

  const onClickFavorite = (flag) => {
    let filteredData1 = myStat.recentRatings.filter((obj) => {
      if (obj.questionUuid === props.data.questionUuid) {
        obj.favourite = !flag
      }
      return obj;
    })
    let filteredData2 = myStat.bestRatingsData.filter((obj) => {
      if (obj.questionUuid === props.data.questionUuid) {
        obj.favourite = !flag
      }
      return obj;
    })
    let filteredData3 = myStat.worstRatingsData.filter((obj) => {
      if (obj.questionUuid === props.data.questionUuid) {
        obj.favourite = !flag
      }
      return obj;
    })
    let filteredData4 = myStat.betterRatingsData.filter((obj) => {
      if (obj.questionUuid === props.data.questionUuid) {
        obj.favourite = !flag
      }
      return obj;
    })
    markUnmarkFavourite(props.data.questionUuid)
      .then((res) => {
        if (res===undefined) return;
        if (props.value === 1) {
          getRecentRatingsData(filteredData1);
        }
        if (props.value === 2) {
          getBetterRatingsData(filteredData4);
        }
        if (props.value === 3) {
          getBestQuestionsData(filteredData2);
          getWorstQuestionsData(filteredData3);
        }
      })
      .catch((err) => { })
  }

  return (
    <div style={containerStyle}>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <div style={{color:'rgb(92, 102, 123)'}}>
            <h2 onClick={() => openModalOnClick()} style={{ fontSize: "21px", cursor: "pointer" }}>{props.data.questionText}</h2>
          </div>
        </Grid>
        <Grid item xs={4}>
          <div style={{display:'flex', flexWrap:'wrap', alignItems:'baseline'}}>
            {props.value === 1 &&
              <>
                {/* <Rate value={props.data.rating} /> */}
              <Rating rating={props?.data?.rating}/>
              </>}
            {props.value === 2 && <><span style={{fontSize: "12px", color: "#949494"}}>My Rating:&nbsp;</span><Rating rating={props?.data?.myRating} /></>}
            {props.value === 1 &&
              <>
              &nbsp;
                <div style={{ float: "right", display: "flex",alignItems:"center" }}>{getRatingValues()}
                  <span style={{cursor: "pointer"}}>
                    {/* <i className="fa fa-heart" style={{ fontSize:"14px",padding:"3px",color: props.data.favourite === true ? "#fd7400" : "lightgray" }} onClick={() => onClickFavorite(props.data.favourite)}></i> */}
                    {props.data.favourite ? <HeartSelectedIcon onClick={()=>onClickFavorite(props.data.favourite)} style={{marginLeft:'5px'}} /> : <HeartIcon onClick={()=>onClickFavorite(props.data.favourite)} style={{marginLeft:'5px'}} />}
                  </span>
                </div>
              </>
            }
          </div>
          <div>
            {
              props.value === 2 && <><span style={{ fontSize: "12px", color: "#949494" }}>Other Rating:&nbsp;</span>
                <span><Rating rating={props.data.otherExpertRating} /></span>
                <div><span style={{ fontSize: "12px", color: "#949494" }}>({props.data.otherExpertName})</span></div></>
            }
          </div>
          {
            props.value === 3 && <span style={{float:"right"}}>
              {/* <i className="fa fa-heart" style={{ fontSize: "14px", padding: "3px", color: props.data.favourite === true ? "#fd7400" : "lightgray", cursor: "pointer" }} onClick={() => onClickFavorite(props.data.favourite)}></i> */}
              {props.data.favourite ? <HeartSelectedIcon style={{cursor:'pointer'}} onClick={()=>onClickFavorite(props.data.favourite)} /> : <HeartIcon style={{cursor:'pointer'}}  onClick={()=>onClickFavorite(props.data.favourite)} />}
            </span>
          }
        </Grid>
      </Grid>
      {props.value === 3 && props.data.answer && props.data.answer !== '' &&
       <Grid container spacing={2}>
        {
          <Grid item xs={12}>
            <div style={{fontSize:"14px",wordBreak: 'break-word',overflowWrap: 'break-word',color: 'rgb(92, 102, 123)',fontWeight:300,fontFamily:'Inter'}} dangerouslySetInnerHTML={{
              __html: replaceContentEditableText(props.data.answer),
            }}>
            </div>
          </Grid>
        }
      </Grid>}
      <Grid container spacing={2}>
        {(props.value === 1) && <><Grid item xs={8}>
          <Tooltip title={moment(props.data.postedTimestamp).format("LLLL")}><span style={{ fontSize: "12px", color: "#949494" }}>Asked&nbsp;{momentit(props.data.postedTimestamp)}</span></Tooltip>
        </Grid>
          <Grid justifyContent="end" item xs={4}>
            <span onClick={() => openModalOnClick()} style={{ fontSize: "12px", color: "#949494", cursor: "pointer" }}>View Answer {props.value ===2 && "All Answers"}</span>
          </Grid>
        </>}
        {props.value === 2 && 
          <>
            <Grid item xs={8}>
            <Tooltip title={moment(props.data.postedTimestamp).format("LLLL")}>
              <span style={{ fontSize: "12px", color: "#949494" }}>Asked&nbsp;{momentit(props.data.answeredTimestamp)}
            </span>
            </Tooltip>
            </Grid>
            <Grid item xs={3}>
            <span onClick={() => openModalOnClick()} style={{ fontSize: "12px", color: "#949494", cursor: "pointer" }}>View All Answers</span>
            </Grid>
          </>
        }
        {
          props.value === 3 &&
          <>
            <Grid item xs={6}>
              <Tooltip title={moment(props.data.postedTimestamp).format("LLLL")}>
                <span style={{ fontSize: "12px", color: "#949494" }}>Asked&nbsp;{momentit(props.data.postedTimestamp)}</span>
              </Tooltip>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "right" }}>
              <Rating rating={props.data.rating} />
            </Grid>
          </>
        }
      </Grid>
    </div>
  )
}